import { useEffect, useState } from 'preact/hooks'

import { CurrencyValueForm } from 'models/apps'
import { CurrencyMinimalAmount } from 'models/settings'

import { localeStringToFloat } from 'utils/format-number'

interface MinimalAmountHookProps {
  value: CurrencyValueForm
  minimalAmounts: CurrencyMinimalAmount[]
  baseCurrency: string
  counterCurrency: string
}

export function useMinimalAmount({ value, minimalAmounts, baseCurrency, counterCurrency }: MinimalAmountHookProps) {
  const [isBelowMinimalAmount, setIsBelowMinimalAmount] = useState(false)

  useEffect(() => {
    const baseMinimal = minimalAmounts.find((a) => a.currency === baseCurrency)?.minimal_local
    const counterMinimal = minimalAmounts.find((a) => a.currency === counterCurrency)?.minimal_local

    const numericValue = Number(localeStringToFloat(value.currentValue))

    const isBaseBelow = numericValue < Number(baseMinimal || 0)
    const isCounterBelow = numericValue < Number(counterMinimal || 0)

    setIsBelowMinimalAmount(isBaseBelow || isCounterBelow)
  }, [value, baseCurrency, counterCurrency, minimalAmounts])

  return { isBelowMinimalAmount }
}
